import React from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import ProductList from "./ProductList";
import LeftSidebar from "./LeftSidebar";

const Marketplace = ({ themeColor }) => {
  return (
    <div
      style={{
        background: `linear-gradient(360deg, ${themeColor} -700%, #eef2ff30)`,
      }}
    >
      <Container>
        <Row>
          <Form.Group as={Col} md={3} className="border-end">
            <LeftSidebar themeColor={themeColor} />
          </Form.Group>
          <Form.Group as={Col} md={9} className="p-0">
            <ProductList themeColor={themeColor} />
          </Form.Group>
        </Row>
      </Container>
    </div>
  );
};

export default Marketplace;
